import { render } from "./custbooking.vue?vue&type=template&id=44de78f8"
import script from "./custbooking.vue?vue&type=script&lang=js"
export * from "./custbooking.vue?vue&type=script&lang=js"

import "./custbooking.vue?vue&type=style&index=0&id=44de78f8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__